export { selectUnit } from './diff';
export { defaultNumberOption, getAliasesByLang, getInternalSlot, getMultiInternalSlots, getNumberOption, getOption, getParentLocalesByLang, isLiteralPart, partitionPattern, setInternalSlot, setMultiInternalSlots, setNumberFormatDigitOptions, toObject, objectIs, isWellFormedCurrencyCode, toString, } from './polyfill-utils';
export { createResolveLocale, getLocaleHierarchy, supportedLocales, unpackData, isMissingLocaleDataError, } from './resolve-locale';
export * from './units';
export * from './number-types';
export { getCanonicalLocales } from './get-canonical-locales';
export { invariant } from './invariant';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@formatjs/intl-pluralrules/~/@formatjs/intl-utils/lib/index.js
// module id = 1454
// module chunks = 121